export default "__VITE_ASSET__C3AFAVE3__"